import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzEaster75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_75: Record<
  Exclude<PageIdWoofzEaster75, PageIdWoofzEaster75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_EASTER_75]: {
    id: PageId.SUBSCRIPTIONS_EASTER_75,
  },
  [PageId.CHAT_UPSELL_EASTER_75]: {
    id: PageId.CHAT_UPSELL_EASTER_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EASTER_75]: {
    id: PageId.UPSELL_EASTER_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_EASTER_75]: {
    id: PageId.DOWNLOAD_EASTER_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
